export default "__VITE_ASSET__$CSdE7FC__"